import { render, staticRenderFns } from "./AddSkill.vue?vue&type=template&id=352f863c&scoped=true"
import script from "./AddSkill.vue?vue&type=script&lang=js"
export * from "./AddSkill.vue?vue&type=script&lang=js"
import style0 from "./AddSkill.vue?vue&type=style&index=0&id=352f863c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f863c",
  null
  
)

export default component.exports